import { VHeaders } from '@/models/pagedlistmodel';



export function getShiftHeaders(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t('shifts.shiftGridHeaders.name') as string,
      align: 'left',
      value: 'name',
      sortable: true,
    },
    {
      text: vm.$parent.$t('shifts.shiftGridHeaders.startTime') as string,
      align: 'left',
      value: 'startTime',
    },
    {
      text: vm.$parent.$t('shifts.shiftGridHeaders.endTime') as string,
      align: 'left',
      value: 'endTime',
    },
    {
      text: vm.$parent.$t('shifts.shiftGridHeaders.action') as string,
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];
}
